<template>
  <multiselect
      v-model="selectedDriver"
      @update:modelValue="onSelectDriver"
      :options="driversList"
      :placeholder="$t('settings.generic.select-items')"
      label="name" track-by="id"
      class="tracking-multiselect fit-content drivers-select"
      :multiple="false"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      :show-labels="false"
      :show-no-results="false"
      :show-no-options="false"
      :allow-empty="false"
  >
    <template #placeholder>
      <span>
        {{ $t('settings.generic.select-placeholder') }}
      </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import {entityDataManager} from "@/assets/js/data-manipulation";

export default {
  name: "ChooseDriver",
  components: {Multiselect},
  props: {
    modelValue: {
      type: [Object],
      default() { return null; }
    },
    addAllOption: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      selectedDriver: this.modelValue,
    }
  },
  computed: {
    ...mapState(['drivers']),
    driversList() {
      const drivers = [...this.drivers].sort((a, b) => a.name.localeCompare(b.name));
      if (this.addAllOption) {
        drivers.unshift({id: null, name: this.$t('generic.all')});
      }

      return drivers;
    },
  },
  mounted() {
    if (this.selectedDriver || this.addAllOption) {
      const selectedDriver = entityDataManager.getById(this.driversList, this.selectedDriver?.id ?? null);
      this.onSelectDriver(selectedDriver, false);
    }
  },
  watch: {
    modelValue(value) {
      const selectedDriver = entityDataManager.getById(this.driversList, value?.id ?? null);
      this.onSelectDriver(selectedDriver, false);
    }
  },
  methods: {
    onSelectDriver(data, triggerValueUpdate = true) {
      this.selectedDriver = data;
      if (triggerValueUpdate) {
        this.$emit('update:modelValue', !this.selectedDriver?.id ? null : this.selectedDriver);
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.drivers-select {
  width: 240px;
}

// Mobile:
@media (max-width: $breaking-point) {
  .drivers-select {
    width: 100%;
  }
}
</style>